<template>
    <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.88825 7.82031L1.86636 9.00897L0 12.2934L7.68318 7.82031H3.88825Z"
            fill="#874691"
        />
        <path
            d="M9.70549 4.44189L7.6836 5.63056L5.78613 8.91501L13.4693 4.44189H9.70549Z"
            fill="#DA1844"
        />
        <path
            d="M7.6836 3.28446L5.78613 0V15.6403L7.6836 12.3558V3.28446Z"
            fill="#F9B229"
        />
        <path
            d="M5.78613 0L7.6836 3.28446L9.70549 4.44184H13.5004L5.78613 0Z"
            fill="#F07F1A"
        />
        <path
            d="M5.78613 6.7251V15.6401L7.6836 12.3556V10.0096L5.78613 6.7251Z"
            fill="#72B22C"
        />
        <path
            d="M9.70549 11.1982L7.6836 12.3556L5.78613 15.6401L13.4693 11.1982H9.70549Z"
            fill="#00743E"
        />
        <path
            d="M0 3.37842V12.2934L1.89746 9.00892V6.6316L0 3.37842Z"
            fill="#5F5A94"
        />
        <path
            d="M5.78571 6.72544L0 3.37842L1.89746 6.6316L9.70507 11.1986H13.5L5.78571 6.72544Z"
            fill="#0D90CD"
        />
    </svg>
</template>
